import React from 'react';
import PropTypes from 'prop-types';

import * as S from './AnnouncementStyles';

function Announcement({ show = false, url }) {
  return show && url ? (
    <S.Container>
      <S.Image src={url} />
    </S.Container>
  ) : null;
}

Announcement.propTypes = {
  show: PropTypes.bool,
  url: PropTypes.string
};

export default Announcement;
